import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Home";
import Fee from "./mission/Fee";
import MissionPrivacyPolicy from "./mission/Privacy_policy";
import MissionTerms from "./mission/Terms";
import Withdrawal from "./mission/Withdrawal";
import MissionDeleteApp from "./mission/Delete_app";
import TodoDeleteApp from "./todo/Delete_app";
import TodoPrivacyPolicy from "./todo/Privacy_policy";
import TodoTerms from "./todo/Terms";
import MoneyDeleteApp from "./money/Delete_app";
import MoneyFee from "./money/Fee";
import MoneyPrivacyPolicy from "./money/Privacy_policy";
import MoneyTerms from "./money/Terms";
import MoneyWithdrawal from "./money/Withdrawal";
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mission/terms" element={<MissionTerms />} />
        <Route path="/mission/privacy_policy" element={<MissionPrivacyPolicy />} />
        <Route path="/mission/fee" element={<Fee />} />
        <Route path="/mission/withdrawal" element={<Withdrawal />} />
        <Route path="/mission/delete_app" element={<MissionDeleteApp />} />
        <Route path="/todo/terms" element={<TodoTerms />} />
        <Route path="/todo/privacy_policy" element={<TodoPrivacyPolicy />} />
        <Route path="/todo/delete_app" element={<TodoDeleteApp />} />
        <Route path="/money/terms" element={<MoneyTerms />} />
        <Route path="/money/privacy_policy" element={<MoneyPrivacyPolicy />} />
        <Route path="/money/fee" element={<MoneyFee />} />
        <Route path="/money/withdrawal" element={<MoneyWithdrawal />} />
        <Route path="/money/delete_app" element={<MoneyDeleteApp />} />
      </Routes>
    </Router>
  );
}

export default App;
